import AuthService from '../services/auth.service';
const user = JSON.parse(localStorage.getItem('user'));
const initialState = user
  ? {  isLoadingUser: false, status: { loggedIn: true }, user }
  : {  isLoadingUser: false, status: { loggedIn: false }, user: null };
export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    async getUserInfo({ commit, state }) {
      if (state.isLoadingUser) {
        return;
      }
      commit('setLoadingUser', true);
      try {
        const user = JSON.parse(localStorage.getItem('user'));
        const wpToken = user ? user.jwt_token : null;

        if (!wpToken) {
          return Promise.reject(new Error('Missing wpToken token'));
        }

        const fetchedUser = await AuthService.getUserInfo(wpToken);
        commit('loginSuccess', fetchedUser);
      } finally {
        commit('setLoadingUser', false);
      }
    },
    integrateUseme({ commit }, formData) {
      return AuthService.integrateUseme(formData).then(
        (response) => {
          commit('updateBillingSuccess', { useme_email: formData.payoutEmail });
          return Promise.resolve(response.data);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    updateBilling({ commit }, formData) {
      return AuthService.updateBilling(formData).then(
        (response) => {
          commit('updateBillingSuccess', formData);
          return Promise.resolve(response.data);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    updateGlobalSaleSettings({ commit }, data) {
      return AuthService.updateGlobalSaleSettings(data).then(
        (response) => {
          commit('updatePhotoSettingsSuccess', response.data.data);
          return Promise.resolve(response.data);
        },
        (error) => Promise.reject(error)
      );
    },
    updateEventPhotoSettings({ commit }, data) {
      return AuthService.updateEventPhotoSettings(data).then(
        (response) => {
          commit('updateEventPhotoSettings', response.data.data);
          return Promise.resolve(response.data);
        },
        (error) => Promise.reject(error)
      );
    },
    updatePhotographerProfile({ commit }, data) {
      return AuthService.updatePhotographerProfile(data).then(
        (response) => {
          commit('updatePhotographerProfileSuccess', response.data.data);
          return Promise.resolve(response.data);
        },
        (error) => Promise.reject(error)
      );
    },
    login({ commit }, user) {
      return AuthService.login(user).then(
        (user) => {
          commit('loginSuccess', user);
          return Promise.resolve(user);
        },
        (error) => {
          commit('loginFailure');
          return Promise.reject(error);
        }
      );
    },
    logout({ commit }) {
      AuthService.logout();
      commit('logout');
      commit('global/resetUserData', {}, { root: true });
    },
    register({ commit }, user) {
      return AuthService.register(user).then(
        (response) => {
          commit('registerSuccess');
          return Promise.resolve(response.data);
        },
        (error) => {
          commit('registerFailure');
          return Promise.reject(error);
        }
      );
    },
    changeUserData({ commit }, user) {
      commit('setUser', user);
    },
    resetPassword(_, { email, key, newPassword, newPasswordConfirmation }) {
      return AuthService.resetPassword(
        email,
        key,
        newPassword,
        newPasswordConfirmation
      ).then(
        (response) => {
          return Promise.resolve(response.data);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {
    updateBillingSuccess(state, billingData) {
      if (state.user) {
        state.user = { ...state.user, ...billingData };
      }
    },
    updatePhotoSettingsSuccess(state, payload) {
      if (state.user) {
        state.user = { ...state.user, ...payload };
      }
    },
    updateEventPhotoSettings(state, payload) {
      if (state.user) {
        state.user = { ...state.user, ...payload };
      }
    },
    updatePhotographerProfileSuccess(state, payload) {
      if (state.user) {
        state.user = { ...state.user, ...payload };
      }
    },
    setUser(state, user) {
      state.user = user;
    },
    setLoadingUser(state, isLoading) {
      state.isLoadingUser = isLoading;
    },
    loginSuccess(state, user) {
      state.status.loggedIn = true;
      state.user = user;
    },
    loginFailure(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    logout(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    registerSuccess(state) {
      state.status.loggedIn = false;
    },
    registerFailure(state) {
      state.status.loggedIn = false;
    },
  },
};
